import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const SelectSection = ({
  className,
  label,
  name,
  value,
  onChange,
  disabled,
  data,
}) => (
  <div className={`form-group col-xs-12 ${className}`}>
    <label htmlFor={name}>{label}</label>
    <select
      id={name}
      name={name}
      onChange={onChange}
      value={value}
      disabled={disabled}
      className="form-control"
    >
      {data.map(e => (
        <option key={e.text} value={e.value}>
          {e.text}
        </option>
      ))}
    </select>
  </div>
);

SelectSection.propTypes = {
  className: PropTypes.string,
  data: PropTypes.array,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default SelectSection;
